module.exports = __webpack_public_path__ + "img/doppler_ruby.a2ca6aa7.svg";